import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { ApiError } from '../api/client.js';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
      const dest = location.state?.from || '/';
      navigate(dest, { replace: true });
    } catch (err) {
      if (err instanceof ApiError && (err.status === 401 || err.status === 403)) {
        setError(err.message || 'Invalid credentials.');
      } else {
        setError('Could not sign in. Please try again.');
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-screen">
      <div className="login-screen__glow" aria-hidden="true" />
      <div className="login-card">
        <div className="login-card__brand">
          <span className="login-card__logo-mark">B</span>
          <div className="login-card__wordmark">
            Bid<span className="login-card__wordmark-accent">Digi</span>
          </div>
        </div>
        <div className="login-card__eyebrow">Operator Console</div>
        <p className="login-card__subtitle">Sign in to manage publishers, demand, and supply.</p>

        <form onSubmit={handleSubmit} className="login-form">
          <label className="field">
            <span className="field__label">Email</span>
            <input
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@biddigi.com"
            />
          </label>
          <label className="field">
            <span className="field__label">Password</span>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;"
            />
          </label>

          {error && <div className="form-error" role="alert">{error}</div>}

          <button type="submit" className="btn btn--primary btn--block" disabled={submitting}>
            {submitting ? 'Signing in&hellip;' : 'Sign in'}
          </button>
        </form>

        <div className="login-card__footnote">Restricted to BidDigi operators only.</div>
      </div>
    </div>
  );
}
